export default {
  namespaced: true,
  state: {
    availableAttributes: [],
    selectedAttributes: [],
    keyword: "",
    menu: [],
  },
  getters: {
    getAvailableAttributes: state => state.availableAttributes,
    getSelectedAttributes: state => state.selectedAttributes,
    getKeyword: state => state.keyword,
    getVisibleItems: state => {
      return state.menu.items?.reduce((prev, list) => {
        let items = list.items.filter(item => {
          if (
            !state.selectedAttributes.length ||
            item.attributes?.some(val => state.selectedAttributes.includes(Object.keys(val)[0]))
          ) {
            return item;
          }
        });
        if (state.keyword) {
          items = items.filter(item => {
            return item.title.toLowerCase().includes(state.keyword.toLowerCase());
          });
        }
        if (items.length > 0) prev.push({ ...list, items });
        return prev;
      }, []);
    },
  },
  actions: {
    setSelectedAttributes: ({ commit }, attribute) => {
      commit("setSelectedAttributes", attribute);
    },
    setKeyword: ({ commit }, keyword) => {
      commit("setKeyword", keyword);
    },
    setMenu: ({ commit }, menu) => {
      commit("setMenu", menu);
    },
  },
  mutations: {
    setMenu: (state, menu) => {
      state.menu = menu;
      state.availableAttributes = menu.attributes || [];
    },
    setSelectedAttributes: (state, attribute) => {
      if (state.selectedAttributes.includes(attribute)) {
        state.selectedAttributes = state.selectedAttributes.filter(item => item !== attribute);
      } else {
        state.selectedAttributes.push(attribute);
      }
    },
    setKeyword: (state, keyword) => {
      state.keyword = keyword;
    },
  },
};
